import Axios from '@/services/axios-instance/axios.service';

class RequestsService {
  async getRequests() {
    const { data } = await Axios.get('/requests');
    return data;
  }
  async createRequest(req) {
    const { data } = await Axios.post('/requests/create-request', req);
    return data;
  }
  async cloneRequest(req) {
    const { data } = await Axios.post('/requests/clone-request', req);
    return data;
  }
  async getNewRequestDetails(req) {
    const { data } = await Axios.post('/requests/new-request/details', req);
    return data;
  }
  async getRequestDetails(req) {
    const { data } = await Axios.post('/requests/view-request/details', req);
    return data;
  }
  async getInviteDetails(req) {
    const { data } = await Axios.post('/requests/view-request/invite-details', req);
    return data;
  }
  async acceptInvite(req) {
    const { data } = await Axios.post('/requests/view-request/accept-invite', req);
    return data;
  }
  async rejectInvite(req) {
    const { data } = await Axios.post('/requests/view-request/reject-invite', req);
    return data;
  }
  async submitRequest(req) {
    const { data } = await Axios.post('/requests/new-request/submit', req);
    return data;
  }
  async deleteRequest(req) {
    const { data } = await Axios.post('/requests/new-request/delete', req);
    return data;
  }
  // Categories
  async searchCategories(req) {
    const { data } = await Axios.post('/requests/new-request/search-categories', req);
    return data;
  }
  async addNewCategory(req) {
    const { data } = await Axios.post('/requests/new-request/add-category', req);
    return data;
  }
  async updateCategory(req) {
    const { data } = await Axios.post('/requests/new-request/update-category', req);
    return data;
  }
  async deleteCategory(req) {
    const { data } = await Axios.post('/requests/new-request/delete-category', req);
    return data;
  }
  // Questions
  async searchQuestions(req) {
    const { data } = await Axios.post('/requests/new-request/search-questions', req);
    return data;
  }
  async addNewQuestion(req) {
    const { data } = await Axios.post('/requests/new-request/add-question', req);
    return data;
  }
  async updateQuestion(req) {
    const { data } = await Axios.post('/requests/new-request/update-question', req);
    return data;
  }
  async deleteQuestion(req) {
    const { data } = await Axios.post('/requests/new-request/delete-question', req);
    return data;
  }
  // Suppliers
  async getInvitedSuppliers(req) {
    const { data } = await Axios.post('/requests/new-request/invited-suppliers', req);
    return data;
  }
  async getNoInvitedSuppliers(req) {
    const { data } = await Axios.post('/requests/new-request/no-invited-suppliers', req);
    return data;
  }
  async addInviteSupplier(req) {
    const { data } = await Axios.post('/requests/new-request/add-invite', req);
    return data;
  }
  async deleteInviteSupplier(req) {
    const { data } = await Axios.post('/requests/new-request/delete-invite', req);
    return data;
  }
}

export default new RequestsService();
